"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStdout = void 0;
const parse_digraph_1 = require("../parse-digraph");
const logLabel = /^\[\w+\]\s*/gm;
const errorLabel = /^\[ERROR\]/gm;
// Parse the output from 'mvn dependency:tree -DoutputType=dot'
function parseStdout(stdout) {
    if (errorLabel.test(stdout)) {
        throw new Error('Maven output contains errors.');
    }
    const withoutLabels = stdout.replace(logLabel, '');
    const digraphs = (0, parse_digraph_1.parseDigraph)(withoutLabels);
    if (!digraphs) {
        throw new Error('Cannot find any digraphs.');
    }
    return digraphs;
}
exports.parseStdout = parseStdout;
//# sourceMappingURL=stdout.js.map